import type { ZimbabweProvinceLocations } from "../api/types";

type Province = {
  id: string;
  name: string;
  districts: string[];
};

const PROVINCES: Province[] = [
  {
    id: "bulawayo",
    name: "Bulawayo",
    districts: ["Bulawayo"],
  },
  {
    id: "harare",
    name: "Harare",
    districts: ["Harare"],
  },
  {
    id: "manicaland",
    name: "Manicaland",
    districts: ["Buhera", "Chimanimani", "Chipinge", "Makoni", "Mutare", "Mutasa", "Nyanga"],
  },
  {
    id: "mashonaland-central",
    name: "Mashonaland Central",
    districts: ["Bindura", "Guruve", "Mazowe", "Mbire", "Mount Darwin", "Muzarabani", "Rushinga", "Shamva"],
  },
  {
    id: "mashonaland-east",
    name: "Mashonaland East",
    districts: [
      "Chikomba",
      "Goromonzi",
      "Marondera",
      "Mudzi",
      "Murehwa",
      "Mutoko",
      "Seke",
      "Uzumba-Maramba-Pfungwe",
      "Wedza",
    ],
  },
  {
    id: "mashonaland-west",
    name: "Mashonaland West",
    districts: ["Chegutu", "Chinhoyi", "Hurungwe", "Kariba", "Makonde", "Mhondoro-Ngezi", "Sanyati", "Zvimba"],
  },
  {
    id: "masvingo",
    name: "Masvingo",
    districts: ["Bikita", "Chiredzi", "Chivi", "Gutu", "Masvingo", "Mwenezi", "Zaka"],
  },
  {
    id: "matabeleland-north",
    name: "Matabeleland North",
    districts: ["Binga", "Bubi", "Hwange", "Lupane", "Nkayi", "Tsholotsho", "Umguza"],
  },
  {
    id: "matabeleland-south",
    name: "Matabeleland South",
    districts: ["Beitbridge", "Bulilima", "Gwanda", "Insiza", "Mangwe", "Matobo", "Umzingwane"],
  },
  {
    id: "midlands",
    name: "Midlands",
    districts: ["Chirumhanzu", "Gokwe North", "Gokwe South", "Gweru", "Kwekwe", "Mberengwa", "Shurugwi", "Zvishavane"],
  },
];

export const ZIMBABWE_PROVINCES_FALLBACK: ZimbabweProvinceLocations[] = PROVINCES.map((province) => ({
  id: province.id,
  name: province.name,
  districts: province.districts.map((district) => ({
    id: `${province.id}-${district.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    name: district,
  })),
}));
